import { Component, PropsWithChildren, ReactNode } from "react";

type Props = PropsWithChildren<{
  /** Rendered instead of the children after a render or data error. */
  fallback?: ReactNode;
}>;

/**
 * Contains errors from optional content so they cannot unmount the app.
 * Modals render outside the app's ErrorBoundary, so an uncaught error there
 * would otherwise take down the whole page.
 */
export class QuietErrorBoundary extends Component<Props, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  render() {
    return this.state.failed
      ? (this.props.fallback ?? null)
      : this.props.children;
  }
}
